"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*globals Kobo, resources*/
(function () {
  Kobo.Utilities.assignToNamespace('Kobo.Enums.BookLayout', Kobo.Enum.define({
    Unknown: ['Unknown', 0],
    Reflowable: ['Reflowable', 1],
    FixedLayout: ['FixedLayout', 2],
    PDF: ['PDF', 3]
  }));

  var BookLayoutExtensions = /*#__PURE__*/function () {
    function BookLayoutExtensions() {
      _classCallCheck(this, BookLayoutExtensions);
    }

    _createClass(BookLayoutExtensions, null, [{
      key: "mapToResourceString",
      value: function mapToResourceString(bookLayout) {
        var _map;

        var BookLayout = Kobo.Enums.BookLayout,
            resourceStrings = resources.getString('bookLayout');
        var map = (_map = {}, _defineProperty(_map, BookLayout.Reflowable, resourceStrings.reflowable), _defineProperty(_map, BookLayout.FixedLayout, resourceStrings.fixedLayout), _defineProperty(_map, BookLayout.PDF, resourceStrings.pdf), _map);
        return map[bookLayout] || '';
      }
    }]);

    return BookLayoutExtensions;
  }();

  Kobo.Utilities.assignToNamespace('Kobo.Enums.BookLayout.Extensions', BookLayoutExtensions);
})();